module.exports = __webpack_public_path__ + "img/perforaciones_4-3_3072.768619b5.jpg";